<template>
    <div class="mx-1 mx-lg-2">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.calendar") }}</h3>
            </div>
            <div class="card-body">
                <Calendar />
            </div>
        </div>
    </div>
</template>

<script>
import Calendar from '@/views/Calendar.vue';

export default {
    components: {
        Calendar,
    },
    data() {
        return {
        }
    }
}
</script>
<style lang="scss">
</style>